import styled from '@emotion/styled'

export const Grid = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	min-height: 100vh;
`;

export const Main = styled.main`
	display: flex;
	justify-content: center;
	flex: 100%;
`;